import { render, staticRenderFns } from "./roundImage.vue?vue&type=template&id=449063f1&scoped=true&"
import script from "./roundImage.vue?vue&type=script&lang=js&"
export * from "./roundImage.vue?vue&type=script&lang=js&"
import style0 from "./roundImage.vue?vue&type=style&index=0&id=449063f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449063f1",
  null
  
)

export default component.exports